import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { DefaultAvatar } from 'atoms/default-avatar';
import { closeDrawer } from 'store/reducers/ui';
import { isEmpty, prettifyPhoneNumber } from 'util';

export default function PetServiceInfo() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { animal, dateStart, service, user } = useSelector(
    (state) => state.appointment
  );

  if (!animal || isEmpty(animal) || !user || isEmpty(user)) return null;

  const petAvatar = animal?.avatarUrls?.mobile?.small;

  const petDetails = [];
  if (animal.breed?.value) petDetails.push(animal.breed?.value);
  if (animal.size?.value) petDetails.push(animal.size?.value);
  if (animal.vaccinations?.length > 0) petDetails.push('Vaccinated');

  return (
    <div className="flex-row align-start mb-12 p-24 border-light-purple radius-24">
      <button
        onClick={() => {
          navigate(`/pet-profile/${animal.uuid}`);
          dispatch(closeDrawer());
        }}
        className="no-style-btn pointer"
      >
        <DefaultAvatar avatar={petAvatar} size="small" animal={animal} />
      </button>
      <div className="flex-column ml-8">
        <p className="f11 c-primary-purple bold">
          {dayjs(new Date(dateStart)).format('MMMM DD, h:mma')}
        </p>
        {service && (
          <p className="f13 bold">{`${service.name} (${service.price.localized})`}</p>
        )}
        <p className="f11">
          <span className="bold">{animal.name}: </span>
          {petDetails.join(' • ')}
        </p>
        <p className="f11">
          <span className="bold">
            {user.firstName} {user.lastName}:{' '}
          </span>
          {user.phone
            ? prettifyPhoneNumber({
                number: user.phone.number,
                countryCode: user.phone.country?.code.value,
              })
            : ''}
        </p>
      </div>
    </div>
  );
}
